<template>
  <div class="footer text-white">
    <div v-if="$config.langs.length > 1" class="language-selector">
      <div
        v-for="_lang in $config.langs"
        class="language-selector__lang"
        :class="{ 'language-selector__lang--active': _lang.code === lang.code }"
        :key="_lang.code"
        @click="setLanguage(_lang)"
      >
        {{ _lang.code }}
      </div>
    </div>
    <div v-if="$config.footerLogo" class="footer__logo">
      <img :src="$config.footerLogo" alt="" />
    </div>
    <div class="footer__socials flex flex-wrap w-full justify-center mb-5">
      <a
        v-if="$config.links.facebook"
        :href="$config.links.facebook"
        target="_blank"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-facebook"
        >
          <path
            d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
          ></path>
        </svg>
      </a>
      <a
        v-if="$config.links.instagram"
        :href="$config.links.instagram"
        target="_blank"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="#ffffff"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-instagram"
        >
          <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
          <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
          <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg
      ></a>
      <a
        v-if="$config.links.twitter"
        :href="$config.links.twitter"
        target="_blank"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-twitter"
        >
          <path
            d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"
          ></path>
        </svg>
      </a>
      <a
        v-if="$config.links.linkedin"
        :href="$config.links.linkedin"
        target="_blank"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-linkedin"
        >
          <path
            d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"
          ></path>
          <rect x="2" y="9" width="4" height="12"></rect>
          <circle cx="4" cy="4" r="2"></circle>
        </svg>
      </a>
      <a
        v-if="$config.links.youtube"
        :href="$config.links.youtube"
        target="_blank"
        ><svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          stroke="#ffffff"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-youtube"
        >
          <path
            d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"
          ></path>
          <polygon
            points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"
          ></polygon>
        </svg>
      </a>
    </div>
    <div v-if="$config.contact.phone" class="footer__details">
      <div class="text-right">
        <span>Phone</span>
      </div>
      <div class="text-left mb-4">
        <a :href="`tel:${$config.contact.phone.replace(/\s/g, '')}`">{{
          $config.contact.phone
        }}</a>
      </div>
    </div>
    <div class="text-sm text-center mb-3">
      <span v-if="$config.contact.address" v-html="$config.contact.address" />
      <a
        v-if="$config.contact.website"
        class="block mt-3"
        :href="$config.contact.website"
        target="_blank"
        ><span>{{ $config.contact.website }}</span></a
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["lang"]),
  },

  methods: {
    setLanguage(lang) {
      this.$store.state.lang = lang;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/styles/_variables";
.language-selector {
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  margin-bottom: 2em;

  &__lang {
    padding: 10px;
    border: 1px solid var(--text-color);
    color: var(--text-color);
    margin: 0 0.5em;
    cursor: pointer;

    &--active {
      background: var(--text-color);
      color: var(--brand-color);
    }
  }
}
.footer {
  background-color: $brand-color;
  padding: 30px 0;

  &__logo {
    display: flex;
    justify-content: center;

    img {
      margin: 0 0 20px;
      max-width: 300px;
    }
  }

  &__socials {
    color: $brand-color;
    display: flex;
    justify-content: center;

    a {
      background: #fff;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      margin: 0 5px;
      position: relative;
      width: 40px;
      // opacity: 0.8;

      &:hover,
      &:focus {
        opacity: 0.8;
      }
    }
  }

  &__details {
    display: flex;

    > div {
      line-height: 1.3;
      padding: 0.5em;
      width: 50%;
    }
  }

  span {
    font-size: 14px;
    opacity: 0.8;
  }
}
</style>
